// import React, { useState, useEffect } from 'react';
// import './OrderHistory.css';
// import apple from '../Assets/greenapple.png';
// import Dashboardmy from '../Dashboard-component/Dashboard';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { getWithTokenAPI, postWithTokenAPI } from '../../util/Api';
// import { ToastContainer, toast } from 'react-toastify';
// import { FaStar } from 'react-icons/fa';
// import 'react-toastify/dist/ReactToastify.css';
// import '../Checkout/checkout.css';

// import { Helmet } from 'react-helmet';


// const OrderHistory = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [orderDetails, setOrderDetails] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [review, setReview] = useState('');
//   const [rating, setRating] = useState(5);
//   const [submittingReview, setSubmittingReview] = useState(false);
//   const [hoverRating, setHoverRating] = useState(0);
//   const [showReviewModal, setShowReviewModal] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [orderaddress, setOrderaddress] = useState(null);
//   const accessToken = useSelector((state) => state.auth?.auth?.access_token);
//   const userId = useSelector((state) => state.auth?.auth?._id);
//   const name = useSelector((state) => state.auth?.auth?.name);
//   useEffect(() => {
//     if (!accessToken) {
//       toast.error('Please login to view order details');
//       navigate('/login');
//       return;
//     }
//     fetchOrderDetails();
//   }, [accessToken]);

//   const fetchOrderDetails = async () => {
//     try {
//       setLoading(true);
//       const orderId = new URLSearchParams(location.search).get('_id');
//       if (!orderId) {
//         toast.error('Order ID not found');
//         navigate('/order_view');
//         return;
//       }

//       const response = await getWithTokenAPI(accessToken, `/order/find-particular?_id=${orderId}&buyer_id=${userId}&buyer_name=${name}`);
//       if (response?.statusCode === 200 && response.data?.orders) {
//         setOrderDetails(response.data.orders);
//         setOrderaddress(response.data.orders.address_id);
//         console.log('Order Details:', response.data.orders.address_id);
//       } else {
//         console.error('Invalid response format:', response);
//         toast.error('Failed to fetch order details: Invalid response format');
//       }
//     } catch (error) {
//       console.error('Error fetching order details:', error);
//       if (error?.response?.status === 401) {
//         toast.error('Session expired. Please login again');
//         navigate('/login');
//       } else {
//         toast.error('Failed to fetch order details. Please try again later');
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatDate = (dateString) => {
//     try {
//       const date = new Date(dateString);
//       if (isNaN(date.getTime())) {
//         return 'Invalid Date';
//       }
//       return date.toLocaleDateString('en-US', {
//         year: 'numeric',
//         month: 'long',
//         day: 'numeric'
//       });
//     } catch (error) {
//       console.error('Error formatting date:', error);
//       return 'Invalid Date';
//     }
//   };

//   const getActiveSteps = () => {
//     if (!orderDetails?.order_status) return 1;
//     switch (orderDetails.order_status.toLowerCase()) {
//       case 'pending': return 1;
//       case 'processing': return 2;
//       case 'shipped': return 3;
//       case 'delivered': return 4;
//       default: return 1;
//     }
//   };

//   const handleReviewSubmit = async () => {
//     if (!review.trim()) {
//       toast.error('Please enter your review');
//       return;
//     }

//     setSubmittingReview(true);
//     try {
//       const response = await postWithTokenAPI(accessToken, '/review/create', {
//         // order_id: orderDetails._id,
//         rating: rating,
//         review: review.trim(),
//         product_id: selectedProduct.product_id._id
//       });

//       if (response?.statusCode === 200) {
//         toast.success('Review submitted successfully!');
//         setReview('');
//         setRating(5);
//         setShowReviewModal(false);
//         setSelectedProduct(null);
//         // Refresh order details to show the review
//         setTimeout(() => {
//           fetchOrderDetails();
//         }, 2000);
//       } else {
//         toast.error(response?.message || 'Failed to submit review');
//       }
//     } catch (error) {
//       console.error('Error submitting review:', error);
//       toast.error('Failed to submit review. Please try again later.');
//     } finally {
//       setSubmittingReview(false);
//     }
//   };

//   const openReviewModal = (product) => {
//     setSelectedProduct(product);
//     setShowReviewModal(true);
//   };

//   const closeReviewModal = () => {
//     setShowReviewModal(false);
//     setSelectedProduct(null);
//     setReview('');
//     setRating();
//   };

//   const renderStars = (rating = 0, interactive = false) => {
//     return (
//       <div className="star-rating">
//         {[1, 2, 3, 4, 5].map((star) => (
//           <FaStar
//             key={star}
//             className={`star ${star <= (interactive ? (hoverRating || rating) : rating) ? 'active' : ''}`}
//             onClick={interactive ? () => setRating(star) : undefined}
//             onMouseEnter={interactive ? () => setHoverRating(star) : undefined}
//             onMouseLeave={interactive ? () => setHoverRating(0) : undefined}
//             style={{
//               color: star <= (interactive ? (hoverRating || rating) : rating) ? '#ffc107' : '#e4e5e9',
//               cursor: interactive ? 'pointer' : 'default',
//               fontSize: interactive ? '24px' : '18px',
//               marginRight: '4px',
//               transition: 'color 0.2s ease-in-out'
//             }}
//           />
//         ))}
//       </div>
//     );
//   };

//   if (loading) {
//     return <div className="loading">Loading...</div>;
//   }

//   if (!orderDetails) {
//     return <div className="no-orders">Order not found</div>;
//   }

//   const activeSteps = getActiveSteps();

//   const renderReviewModal = () => {
//     if (!showReviewModal || !selectedProduct) return null;

//     return (
//       <div className="review-modal-overlay" onClick={closeReviewModal}>
//         <div className="review-modal" onClick={e => e.stopPropagation()}>
//           <div className="review-modal-header">
//             <h3>Review for {selectedProduct.product_id.name}</h3>
//             <button onClick={closeReviewModal} className="close-button">&times;</button>
//           </div>
//           <div className="review-modal-content">
//             <div className="rating-input">
//               <label>Your Rating:</label>
//               {renderStars(rating, true)}
//             </div>
//             <textarea
//               value={review}
//               onChange={(e) => setReview(e.target.value)}
//               placeholder="Write your review here..."
//               className="review-textarea"
//               rows={4}
//             />
//             <button
//               onClick={handleReviewSubmit}
//               disabled={submittingReview}
//               className="submit-review-btn"
//             >
//               {submittingReview ? 'Submitting...' : 'Submit Review'}
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <>

//       <ToastContainer autoClose={3000} />
//       <Helmet>
//         <title>{`${name} | Order Detail`}</title>
//         <meta name="description" content={`user order detail page of Shambasync`} />
//       </Helmet>
//       <div className='show-content'>
//         <Dashboardmy />
//         {renderReviewModal()}
//         <div className="order-history">
//           {/* Order Header */}
//           <div className="order-header">
//             <div className="order-info">
//               {/* <h2>Order #{orderDetails.order_id}</h2> */}
//               <h2>Order Detail</h2>

//               <span>Placed on {formatDate(orderDetails.created_at)}</span>
//             </div>
//             <button
//               className="back-button"
//               onClick={() => navigate('/order_view')}
//               aria-label="Back to orders"
//             >
//               Back to Orders
//             </button>
//           </div>

//           {/* Billing & Shipping Section */}
//           <div className='two-box-container'>
//             <div className="billing-shipping-card">
//               {/* <div className="section-order billing">
//                 <h3>Billing Address</h3>
//                 <div className="divider-hr" />
//                 <p>{orderDetails.buyer_id?.name || 'N/A'}</p>
//                 <p>{orderDetails.address_id?.street || 'No address provided'}</p>
//                 <p>{orderDetails.address_id ? `${orderDetails.address_id.city}, ${orderDetails.address_id.state}` : 'N/A'}</p>
//                 <p>{orderDetails.address_id ? `${orderDetails.address_id.zip_code}, ${orderDetails.address_id.country}` : 'N/A'}</p>
//                 <p>{orderDetails.buyer_id?.email || 'N/A'}</p>
//               </div>
//               <div className="divider-vertical" /> */}
//               <div className="section-order shipping">
//                 <h3>Shipping Address</h3>
//                 <div className="divider-hr" />
//                 <p>Name : {orderaddress.name || 'N/A'}</p>
//                 <p>Street : {orderaddress.street || 'No address provided'}</p>
//                 <p>City : {orderaddress.city || 'N/A'}</p>
//                 <p>State : {orderaddress.state || 'N/A'}</p>
//                 <p>Zipcode : {orderaddress.zip_code || 'N/A'}</p>
//                 <p>Country : {orderaddress.country || 'N/A'}</p>
//               </div>
//             </div>

//             {/* Order Summary */}
//             <div className="order-summary-box">
//               <div className="order-summary-info">
//                 <div className="summary-block">
//                   <span className="summary-label">Order ID:</span>
//                   <span className="summary-value">{orderDetails.order_id}</span>
//                 </div>
//                 <div className="summary-divider-vertical"></div>
//                 <div className="summary-block">
//                   <span className="summary-label">Payment Method:</span>
//                   <span className="summary-value">{orderDetails.payment_method}</span>
//                 </div>
//               </div>

//               <div className="summary-divider-horizontal"></div>

//               <div className="summary-price-section">
//                 <div className="price-row">
//                   <span>Payment Status:</span>
//                   <span className={`status-badge ${orderDetails.payment_status.toLowerCase()}`}>
//                     {orderDetails.payment_status}
//                   </span>
//                 </div>
//                 <div className="summary-divider-horizontal"></div>
//                 <div className="price-row">
//                   <span>Shipping</span>
//                   <span>{orderDetails.shipping}</span>
//                 </div>
//                 <div className="summary-divider-horizontal"></div>
//                 <div className="price-row">
//                   <span>Order Status</span>
//                   <span className={`status-badge ${orderDetails.order_status.toLowerCase()}`}>
//                     {orderDetails.order_status}
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Progress Tracker */}
//           <div className="progress-tracker">
//             <div className="progress-steps">
//               {['Pending', 'Processing', 'Shipped', 'Delivered'].map((step, index) => (
//                 <div key={step} className="progress-step">
//                   <div className={`step-point ${index < activeSteps ? 'active' : ''}`}>
//                     {index + 1}
//                   </div>
//                   <div className={`step-label ${index < activeSteps ? 'active' : ''}`}>
//                     {step}
//                   </div>
//                 </div>
//               ))}
//             </div>
//             <div className="progress-line">
//               <div
//                 className="progress-active"
//                 style={{ width: `${(activeSteps / 4) * 100}%` }}
//               ></div>
//             </div>
//           </div>

//           {/* Product Table */}
//           <div className="order-products-container" style={{ background: '#fff', borderRadius: 8, marginTop: 24, padding: 0 }}>
//             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//               <thead>
//                 <tr style={{ background: '#f6fef9', color: '#333', fontWeight: 500 }}>
//                   <th style={{ padding: '10px 8px', borderBottom: '1px solid #e6e6e6' }}>SNo</th>
//                   <th style={{ padding: '10px 8px', borderBottom: '1px solid #e6e6e6' }}>Product Name</th>
//                   <th style={{ padding: '10px 8px', borderBottom: '1px solid #e6e6e6' }}>Variant</th>
//                   <th style={{ padding: '10px 8px', borderBottom: '1px solid #e6e6e6' }}>QTY</th>
//                   <th style={{ padding: '10px 8px', borderBottom: '1px solid #e6e6e6' }}>Price</th>
//                   {/* <th style={{ padding: '10px 8px', borderBottom: '1px solid #e6e6e6' }}>Rating</th> */}
//                   <th style={{ padding: '10px 8px', borderBottom: '1px solid #e6e6e6' }}>Review</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {orderDetails?.cart_id?.cart?.map((item, idx) => (
//                   <tr key={item._id} style={{ borderBottom: '1px solid #e6e6e6' }}>
//                     <td style={{ padding: '10px 8px', textAlign: 'center' }}>{idx + 1}</td>
//                     <td style={{ padding: '10px 8px', display: 'flex', alignItems: 'center', gap: 8 }}>
//                       <img
//                         src={item.product_id.product_image[0]}
//                         alt={item.product_id.name}
//                         style={{ width: 67, height: 57, objectFit: 'cover', borderRadius: 4, marginRight: 8 }}
//                         onError={(e) => {
//                           e.target.onerror = null;
//                           e.target.src = apple;
//                         }}
//                       />
//                       {item.product_id.name}
//                     </td>
//                     <td style={{ padding: '10px 8px' }}>{item.product_id.variant || '-'}</td>
//                     <td style={{ padding: '10px 8px' }}>{item.quantity}</td>
//                     <td style={{ padding: '10px 8px' }}>Ksh {item.discount_price}</td>
//                     {/* <td style={{ padding: '10px 8px' }}>
//                       {item.product_id.rating ? renderStars(item.product_id.rating) : '-'}
//                     </td> */}
//                     <td style={{ padding: '10px 8px' }}>
//                       {console.log('Product data for review button:', item.product_id)}
//                       <button
//                         onClick={() => openReviewModal(item)}
//                         className="review-button"
//                         disabled={orderDetails.order_status.toLowerCase() !== 'delivered'}
//                       >
//                         {(item.product_id.reviews && item.product_id.reviews.some(review => review.user_id === userId)) ? 'Reviewed' : 'Review'}
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//             {/* Summary Section */}
//             <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', padding: 16 }}>
//               <div style={{ marginBottom: 4 }}>Sub Total <span style={{ marginLeft: 32, fontWeight: 500 }}>Ksh {orderDetails?.cart_id?.total_Price}</span></div>

//               <div style={{ fontWeight: 700, fontSize: 16 }}>Total <span style={{ marginLeft: 56 }}>Ksh {orderDetails?.cart_id?.total_Price}</span></div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default OrderHistory;


import React, { useState, useEffect } from 'react';
import './OrderHistory.css';
import apple from '../Assets/greenapple.png';
import Dashboardmy from '../Dashboard-component/Dashboard';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getWithTokenAPI, postWithTokenAPI } from '../../util/Api';
import { ToastContainer, toast } from 'react-toastify';
import { FaStar } from 'react-icons/fa';
import { BsEye } from 'react-icons/bs'; // Import BsEye icon for view/track
import 'react-toastify/dist/ReactToastify.css';
import '../Checkout/checkout.css'; // Keep this if it contains shared styles
import { Helmet } from 'react-helmet';

const OrderHistory = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [review, setReview] = useState('');
  const [rating, setRating] = useState(5);
  const [submittingReview, setSubmittingReview] = useState(false);
  const [hoverRating, setHoverRating] = useState(0);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [orderaddress, setOrderaddress] = useState(null);
  const accessToken = useSelector((state) => state.auth?.auth?.access_token);
  const userId = useSelector((state) => state.auth?.auth?._id);
  const name = useSelector((state) => state.auth?.auth?.name);

  const [activeAccordionId, setActiveAccordionId] = useState(null);

  useEffect(() => {
    if (!accessToken) {
      toast.error('Please login to view order details');
      navigate('/login');
      return;
    }
    fetchOrderDetails();
  }, [accessToken, location.search, userId, name, navigate]);

  const fetchOrderDetails = async () => {
    try {
      setLoading(true);
      const orderId = new URLSearchParams(location.search).get('_id');
      if (!orderId) {
        toast.error('Order ID not found');
        navigate('/order_view');
        return;
      }

      const response = await getWithTokenAPI(accessToken, `/order/find-particular?_id=${orderId}&buyer_id=${userId}&buyer_name=${name}`);
      if (response?.statusCode === 200 && response.data?.orders) {
        setOrderDetails(response.data.orders);
        setOrderaddress(response.data.orders.address_id);
        console.log('Order Details:', response.data.orders);
      } else {
        console.error('Invalid response format or no orders:', response);
        toast.error('Failed to fetch order details: Invalid response format or no orders found');
      }
    } catch (error) {
      console.error('Error fetching order details:', error);
      if (error?.response?.status === 401) {
        toast.error('Session expired. Please login again');
        navigate('/login');
      } else {
        toast.error('Failed to fetch order details. Please try again later');
      }
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return 'Invalid Date';
      }
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch (error) {
      console.error('Error formatting date:', error);
      return 'Invalid Date';
    }
  };

  const getActiveSteps = () => {
    if (!orderDetails?.order_status) return 1;
    switch (orderDetails.order_status.toLowerCase()) {
      case 'pending': return 1;
      case 'processing': return 2;
      case 'shipped': return 3;
      case 'delivered': return 4;
      default: return 1;
    }
  };

  const handleReviewSubmit = async () => {
    if (!review.trim()) {
      toast.error('Please enter your review');
      return;
    }

    setSubmittingReview(true);
    try {
      const response = await postWithTokenAPI(accessToken, '/review/create', {
        rating: rating,
        review: review.trim(),
        product_id: selectedProduct.product_id._id,
      });

      if (response?.statusCode === 200) {
        toast.success('Review submitted successfully!');
        setReview('');
        setRating(5);
        setShowReviewModal(false);
        setSelectedProduct(null);
        setTimeout(() => {
          fetchOrderDetails();
        }, 2000);
      } else {
        toast.error(response?.message || 'Failed to submit review');
      }
    } catch (error) {
      console.error('Error submitting review:', error);
      toast.error('Failed to submit review. Please try again later.');
    } finally {
      setSubmittingReview(false);
    }
  };

  const openReviewModal = (product) => {
    setSelectedProduct(product);
    setShowReviewModal(true);
  };

  const closeReviewModal = () => {
    setShowReviewModal(false);
    setSelectedProduct(null);
    setReview('');
    setRating(5);
  };

  const renderStars = (rating = 0, interactive = false) => {
    return (
      <div className="star-rating">
        {[1, 2, 3, 4, 5].map((star) => (
          <FaStar
            key={star}
            className={`star ${star <= (interactive ? (hoverRating || rating) : rating) ? 'active' : ''}`}
            onClick={interactive ? () => setRating(star) : undefined}
            onMouseEnter={interactive ? () => setHoverRating(star) : undefined}
            onMouseLeave={interactive ? () => setHoverRating(0) : undefined}
            style={{
              color: star <= (interactive ? (hoverRating || rating) : rating) ? '#ffc107' : '#e4e5e9',
              cursor: interactive ? 'pointer' : 'default',
              fontSize: interactive ? '24px' : '18px',
              marginRight: '4px',
              transition: 'color 0.2s ease-in-out'
            }}
          />
        ))}
      </div>
    );
  };

  const getStatusClass = (status) => {
        if (!status) return '';
        const statusLower = status.toLowerCase();
        switch (statusLower) {
            case 'pending':
                return 'status-pending'; // Renamed to be more descriptive
            case 'shipped':
                return 'status-shipped'; // Renamed
            case 'delivered':
                return 'status-delivered'; // Renamed
            case 'paid': // Add this new case for "Paid" status
                return 'status-paid';
            default:
                return '';
        }
    };

  const toggleAccordion = (itemId) => {
    setActiveAccordionId(prevId => (prevId === itemId ? null : itemId));
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!orderDetails) {
    return <div className="no-orders">Order not found. Please check the URL or your login status.</div>;
  }

  const activeSteps = getActiveSteps();

  const renderReviewModal = () => {
    if (!showReviewModal || !selectedProduct) return null;

    return (
      <div className="review-modal-overlay" onClick={closeReviewModal}>
        <div className="review-modal" onClick={e => e.stopPropagation()}>
          <div className="review-modal-header">
            <h3>Review for {selectedProduct.product_id.name}</h3>
            <button onClick={closeReviewModal} className="close-button">&times;</button>
          </div>
          <div className="review-modal-content">
            <div className="rating-input">
              <label>Your Rating:</label>
              {renderStars(rating, true)}
            </div>
            <textarea
              value={review}
              onChange={(e) => setReview(e.target.value)}
              placeholder="Write your review here..."
              className="review-textarea"
              rows={4}
            />
            <button
              onClick={handleReviewSubmit}
              disabled={submittingReview}
              className="submit-review-btn"
            >
              {submittingReview ? 'Submitting...' : 'Submit Review'}
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Group products by seller_id
  const productsBySeller = orderDetails?.cart_id?.cart.reduce((acc, item) => {
    const sellerId = item.seller_id;
    if (!acc[sellerId]) {
      acc[sellerId] = [];
    }
    acc[sellerId].push(item);
    return acc;
  }, {});

  const sellerIds = Object.keys(productsBySeller || {});
  const showSubOrders = sellerIds.length > 1;

  const renderProductTable = (products, sellerTitle = '') => (
    <div className="order-products-container" style={{ background: '#fff', borderRadius: 8, marginTop: 24, padding: 0 }}>
      {sellerTitle && <h3 style={{ padding: '10px 16px', borderBottom: '1px solid #e6e6e6', margin: 0 }}>Sub Order</h3>}
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: '#f6fef9', color: '#333', fontWeight: 500 }}>
            <th style={{ padding: '10px 8px', borderBottom: '1px solid #e6e6e6' }}>SNo</th>
            <th style={{ padding: '10px 8px', borderBottom: '1px solid #e6e6e6' }}>Product Name</th>
            <th style={{ padding: '10px 8px', borderBottom: '1px solid #e6e6e6' }}>Variant</th>
            <th style={{ padding: '10px 8px', borderBottom: '1px solid #e6e6e6' }}>QTY</th>
            <th style={{ padding: '10px 8px', borderBottom: '1px solid #e6e6e6' }}>Price</th>
            <th style={{ padding: '10px 8px', borderBottom: '1px solid #e6e6e6' }}>Review</th>
            <th style={{ padding: '10px 8px', borderBottom: '1px solid #e6e6e6' }}>Track</th>
          </tr>
        </thead>
        <tbody>
          {products.map((item, idx) => (
            <React.Fragment key={item._id}>
              <tr style={{ borderBottom: '1px solid #e6e6e6' }}>
                <td style={{ padding: '10px 8px', textAlign: 'center' }}>{idx + 1}</td>
                <td style={{ padding: '10px 8px', display: 'flex', alignItems: 'center', gap: 8 }}>
                  <img
                    src={item.product_id.product_image[0]}
                    alt={item.product_id.name}
                    style={{ width: 67, height: 57, objectFit: 'cover', borderRadius: 4, marginRight: 8 }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = apple;
                    }}
                  />
                  {item.product_id.name}
                </td>
                <td style={{ padding: '10px 8px' }}>{item.product_id.variant || '-'}</td>
                <td style={{ padding: '10px 8px' }}>{item.quantity}</td>
                <td style={{ padding: '10px 8px' }}>Ksh {parseFloat(item.discount_price || item.product_id.price).toFixed(2)}</td>
                <td style={{ padding: '10px 8px' }}>
                  <button
                    onClick={() => openReviewModal(item)}
                    className="review-button"
                    disabled={orderDetails.order_status.toLowerCase() !== 'delivered'}
                  >
                    {(item.product_id.reviews && item.product_id.reviews.some(review => review.user_id === userId)) ? 'Reviewed' : 'Review'}
                  </button>
                </td>
                <td style={{ padding: '10px 8px', textAlign: 'center' }}>
                  <button
                    onClick={() => toggleAccordion(item._id)}
                    className="track-icon-button"
                    aria-expanded={activeAccordionId === item._id}
                    aria-controls={`track-panel-${item._id}`}
                  >
                    <BsEye size={20} style={{ color: '#00b307' }} />
                  </button>
                </td>
              </tr>
              {activeAccordionId === item._id && (
                <tr className="accordion-row">
                  <td colSpan="7" className="accordion-content" id={`track-panel-${item._id}`}>
                    <h6 style={{ marginBottom: '15px', textAlign: 'center', color: '#333' }}>Order Progress for {item.product_id.name}</h6>
                    <div className="progress-tracker product-tracker" style={{ maxWidth: '80%', margin: '0 auto' }}>
                      <div className="progress-steps">
                        {['Pending', 'Processing', 'Shipped', 'Delivered'].map((step, index) => (
                          <div key={step} className="progress-step">
                            <div className={`step-point ${index < activeSteps ? 'active' : ''}`}>
                              {index + 1}
                            </div>
                            <div className={`step-label ${index < activeSteps ? 'active' : ''}`}>
                              {step}
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="progress-line">
                        <div
                          className="progress-active"
                          style={{ width: `${(activeSteps / 4) * 100}%` }}
                        ></div>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
      {/* Summary Section for each table/sub-order (if needed, otherwise remove) */}
   <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', padding: 16 }}>
  {/* Subtotal */}
  <div style={{ marginBottom: 4 }}>
    Sub Total
    <span style={{ marginLeft: 32, fontWeight: 500 }}>
      Ksh {parseFloat(orderDetails.cart_id.total_Price || 0).toFixed(2)}
    </span>
  </div>

  {/* Tax */}
  <div style={{ marginBottom: 4 }}>
    Tax(16%)
    <span style={{ marginLeft: 32, fontWeight: 500 }}>
      Ksh {parseFloat(orderDetails.cart_id.tax || 0).toFixed(2)}
    </span>
  </div>

  {/* Total = Subtotal + Tax */}
  <div style={{ fontWeight: 700, fontSize: 16 }}>
    Total
    <span style={{ marginLeft: 56 }}>
      Ksh {(
        parseFloat(orderDetails.cart_id.total_Price || 0) +
        parseFloat(orderDetails.cart_id.tax || 0)
      ).toFixed(2)}
    </span>
  </div>
</div>

    </div>
  );


  return (
    <>
      <ToastContainer autoClose={3000} />
      <Helmet>
        <title>{`${name} | Order Detail`}</title>
        <meta name="description" content={`user order detail page of Shambasync`} />
      </Helmet>
      <div className='show-content'>
        <Dashboardmy />
        {renderReviewModal()}
        <div className="order-history">
          {/* Order Header */}
          <div className="order-header">
            <div className="order-info">
              <h2>Order Detail</h2>
              <span>Placed on {formatDate(orderDetails.created_at)}</span>
            </div>
            <button
              className="back-button"
              onClick={() => navigate('/order_view')}
              aria-label="Back to orders"
            >
              Back to Orders
            </button>
          </div>

          {/* Billing & Shipping Section */}
          <div className='two-box-container'>
            <div className="billing-shipping-card">
             <div className="shipping-address-card">
  <h3>Shipping Address</h3>
  <div className="divider-hr" /> {/* Assuming you have a divider here */}
  <p><span className="label">Name</span> : <span className="value">{orderaddress?.name || 'N/A'}</span></p>
  <p><span className="label">Street</span> : <span className="value">{orderaddress?.street || 'No address provided'}</span></p>
  <p><span className="label">City</span> : <span className="value">{orderaddress?.city || 'N/A'}</span></p>
  <p><span className="label">State</span> : <span className="value">{orderaddress?.state || 'N/A'}</span></p>
  <p><span className="label">Zipcode</span> : <span className="value">{orderaddress?.zip_code || 'N/A'}</span></p>
  <p><span className="label">Country</span> : <span className="value">{orderaddress?.country || 'N/A'}</span></p>
</div>
            </div>

            {/* Order Summary */}
            <div className="order-summary-box">
              <div className="order-summary-info">
                <div className="summary-block">
                  <span className="summary-label">Order ID:</span>
                  <span className="summary-value">{orderDetails.order_id}</span>
                </div>
                <div className="summary-divider-vertical"></div>
                <div className="summary-block">
                  <span className="summary-label">Payment Method:</span>
                  <span className="summary-value">{orderDetails.payment_method}</span>
                </div>
              </div>

              <div className="summary-divider-horizontal"></div>

              <div className="summary-price-section">
                <div className="price-row">
                  {/* <span>Payment Status:</span>
                  <span className={`status-badge ${orderDetails.payment_status.toLowerCase()}`}>
                    {orderDetails?.cart_id?.payment_status}
                  </span> */}

                   <span>Payment Status:</span>
                   <span className={`status-badge ${getStatusClass(orderDetails?.cart_id?.payment_status)}`}>
                                                        {orderDetails?.cart_id?.payment_status}
                                                    </span>
                </div>
                <div className="summary-divider-horizontal"></div>
                <div className="price-row">
                  <span>Tax(16%)</span>
                  <span>Ksh {parseFloat(orderDetails.cart_id.tax || 0).toFixed(2)}</span>
                </div>
                <div className="summary-divider-horizontal"></div>
                <div className="price-row">
                  <span>Order Status</span>
                  <span className={`status-badge ${orderDetails.order_status.toLowerCase()}`}>
                    {orderDetails.order_status}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Product Tables based on seller_id */}
          {showSubOrders ? (
            sellerIds.map(sellerId => (
              <React.Fragment key={sellerId}>
                {renderProductTable(productsBySeller[sellerId], `Seller ID: ${sellerId}`)}
              </React.Fragment>
            ))
          ) : (
            orderDetails?.cart_id?.cart.length > 0 && renderProductTable(orderDetails.cart_id.cart)
          )}
        </div>
      </div>
    </>
  );
};

export default OrderHistory;